export const damageType = {
  DAUNA_TOTALA: "DAUNA_TOTALA",
  DAUNA: "DAUNA"
};
